/**
 * #context.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
/** The user client hosting the web view. */
export var Client;
(function (Client) {
    Client[Client["CLIENT_UNSPECIFIED"] = 0] = "CLIENT_UNSPECIFIED";
    Client[Client["ANDROID"] = 1] = "ANDROID";
    Client[Client["IOS"] = 2] = "IOS";
    Client[Client["SHREDDIT"] = 3] = "SHREDDIT";
    Client[Client["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Client || (Client = {}));
/**
 * Inline height of post.
 *
 * @deprecated
 */
export var Height;
(function (Height) {
    Height[Height["HEIGHT_UNSPECIFIED"] = 0] = "HEIGHT_UNSPECIFIED";
    Height[Height["REGULAR"] = 1] = "REGULAR";
    Height[Height["TALL"] = 2] = "TALL";
    Height[Height["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Height || (Height = {}));
/** Presentation mode requested when opening the app deep link. */
export var ShareParam_Presentation;
(function (ShareParam_Presentation) {
    ShareParam_Presentation[ShareParam_Presentation["PRESENTATION_UNSPECIFIED"] = 0] = "PRESENTATION_UNSPECIFIED";
    ShareParam_Presentation[ShareParam_Presentation["EXPANDED"] = 1] = "EXPANDED";
    ShareParam_Presentation[ShareParam_Presentation["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ShareParam_Presentation || (ShareParam_Presentation = {}));
